import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/imgs/logo2.png';
const _hoisted_1 = {
  class: "sidebar-container"
};
const _hoisted_2 = {
  class: "logo-container"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "sidebar-logo",
  src: _imports_0
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "sidebar-title"
}, "南乐中兴敬老院管理系统", -1);
const _hoisted_5 = {
  class: "menufold-container"
};
import MenuItem from './components/MenuItem.vue';
import MenuFold from './components/MenuFold.vue';
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import store from '@/store';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    let active = ref('Home');
    // 监听地址栏变化
    watch(() => route, newVal => {
      if (newVal.name) {
        active.value = newVal.name;
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
        title: "南乐中兴敬老院管理系统",
        to: "/"
      }, {
        default: _withCtx(() => [_hoisted_3, _hoisted_4]),
        _: 1
      })]), _createVNode(_component_el_scrollbar, null, {
        default: _withCtx(() => [_createVNode(_component_el_menu, {
          "default-active": String(_unref(active)),
          "unique-opened": "",
          collapse: !_ctx.$store.state.app.siderType
        }, {
          default: _withCtx(() => [_createVNode(MenuItem, {
            menuList: _unref(store).state.app.routeTree
          }, null, 8, ["menuList"])]),
          _: 1
        }, 8, ["default-active", "collapse"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_5, [_createVNode(MenuFold)])]);
    };
  }
});